import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-60cd9a8a")

_pushScopeId("data-v-60cd9a8a")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Try out US stocks")
const _hoisted_2 = { class: "d-f mt-16 px-20" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Make trade of US stocks to get a $1 coupon")
const _hoisted_4 = { style: {"overflow":"hidden"} }
const _hoisted_5 = { class: "flex-1 mx-16 desc" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Pic = _resolveComponent("Pic")
  const _component_Icon = _resolveComponent("Icon")
  const _component_SymbolLink = _resolveComponent("SymbolLink")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_t, {
      as: "p",
      path: "home_14",
      class: "t-center f-xxl f-bold"
    }, {
      default: _withId(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_t, {
        as: "p",
        path: "home_15",
        class: "mr-16"
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_Pic, {
        src: "home/coupon$1",
        width: "80",
        height: "56"
      })
    ]),
    _createVNode("div", _hoisted_4, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.stocks, (item) => {
        return (_openBlock(), _createBlock(_component_SymbolLink, {
          key: item.code,
          code: item.code,
          class: "stock df-middle bg-white br-lg"
        }, {
          default: _withId(() => [
            _createVNode(_component_Pic, {
              src: item.icon,
              width: "48",
              height: "48"
            }, null, 8, ["src"]),
            _createVNode("p", _hoisted_5, _toDisplayString(item.description), 1),
            _createVNode(_component_Icon, {
              name: "caret-right",
              sm: ""
            })
          ]),
          _: 2
        }, 1032, ["code"]))
      }), 128))
    ])
  ], 64))
})